<template>
	<v-row>
		<v-col>
			<v-menu
				:close-on-content-click="false"
				min-width="290px"
				offset-y
				transition="scale-transition"
				v-model="menu"
			>
				<template #activator="{ on }">
					<v-text-field
						:error-messages="$props.error"
						:hide-details="$props.hideDetails"
						:label="dateLabel"
						outlined
						readonly
						v-model="valueFormatted"
						v-on="on"
					></v-text-field>
				</template>
				<v-date-picker :readonly="readonly" @input="menu = false" v-model="selectedValue"></v-date-picker>
			</v-menu>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "DatePicker",
	props: ['readonly', 'value', 'dateLabel', 'error', 'hideDetails'],
	data() {
		return {
			menu: false,
			valueFormatted: null,
			selectedValue: this.$props.value
		}
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != null) {
					if (this.selectedValue != null) {
						if (this.selectedValue.value != newVal) {
							this.setValue(newVal);
						}
					} else {
						this.setValue(newVal);
					}
				} else {
					this.selectedValue = null;
				}
			}
		},
		selectedValue: function (val) {
			this.valueFormatted = this.formatDate(this.selectedValue);
			if (val != null) {
				if (val != this.$props.value) {
					this.$nextTick(() => {
						this.$emit('input', val);
					})
				}
			} else {
				this.$nextTick(() => {
					this.$emit('input', null);
				})
			}
		},
	},
	methods: {
		parseDate(date) {
			if (!date) return null
			const [month, day, year] = date.split('.')
			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
		},
		formatDate(date) {
			if (!date) return null
			const [year, month, day] = date.split('-')
			return `${parseInt(day)}.${parseInt(month)}.${year}.`
		},
		setValue(newVal) {
			this.selectedValue = newVal;
			this.selectedValue = newVal;
		}
	},
	mounted() {
		this.setValue(this.$props.value);
	}
}
</script>

<style scoped>

</style>
